import React from "react";

import {
  RideGlInformationSolid,
  RideInformativePopover,
} from "@rimac-seguros/ride-system-components";

import { Chips } from "@/components/atoms/Chips";

export const CoverageAmount = ({ list, sumAssured, disabled, onSelected }) => {
  const selectSumAssured = (item) => {
    if (sumAssured && sumAssured.value === item.value) return;
    onSelected(item);
  };

  return (
    <div className="relative border-b border-ride-sys-color-border-default">
      <h2 className="flex items-center ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge gap-ride-gl-spacing-large lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
        Elige tu monto de cobertura
        <RideInformativePopover
          glyph={<RideGlInformationSolid />}
          aria-label="Montos de cobertura"
          isNonModal
          size="medium"
          paragraph="Este monto será lo que recibirán tus beneficiarios en caso de fallecimiento."
        />
      </h2>
      <div className="flex overflow-x-auto gap-ride-gl-spacing-large pb-ride-gl-spacing-4xlarge px-ride-gl-spacing-4xlarge -mx-ride-gl-spacing-4xlarge md-special:-mx-ride-gl-spacing-7xlarge md-special:px-ride-gl-spacing-7xlarge md:mx-0 md:px-0 lg:flex-wrap lg:gap-ride-gl-spacing-xlarge">
        {list.map((item) => (
          <Chips
            key={item.value}
            selected={item.value === sumAssured?.value}
            disabled={disabled}
            onClick={() => selectSumAssured(item)}
          >
            {item.text}
          </Chips>
        ))}
      </div>
    </div>
  );
};
